import React, { useEffect } from "react";
import { connect } from "react-redux";
import RightsTable from "./RightsTable/RightsTable";
import * as rk from "../../localization/resourceKeys";
import { withTranslation, Trans } from "react-i18next";
import BottomLine from "../Footer/BottomLine";
import "./requestSelector.css";
import "@reach/skip-nav/styles.css";
import i18n from "../../i18n";
import { clearProtectionServicesExperianDetails } from "../../redux/ProtectionServicesExperianForm/protectionServicesExperianAction";
import PropTypes from "prop-types";

const RequestSelector = (props) => {
  // Making sure the user is redirected to the start of the flow in case the redux store does not have a selected flow,
  // such as when the a user enters directly to the route.
  const { selectedFlow } = props.stateSelector;

  if (!selectedFlow) {
    window.location.replace("/");
  }
  const state = props.stateSelector.currentStateResidence;
  const country = props.country;

  const headerText = (state) => {
    return (
      <Trans
        i18nKey={
          selectedFlow === "check"
            ? rk.REQUEST_SELECTOR.TITLE_QUESTION_CHECK
            : rk.REQUEST_SELECTOR.TITLE_QUESTION
        }
      ></Trans>
    );
  };

  const bottomText = (state) => {
    switch (state) {
      case "QC":
        return (
          <>
            <div id="request-footer-text" className="u-1/1 u-m-none">
              {i18n.t(rk.REQUEST_SELECTOR.QC_BOTTOM_TEXT_1)}
            </div>
            <li id="request-footer-text" className="u-1/1 u-m-none u-pt-small">
              {i18n.t(rk.REQUEST_SELECTOR.QC_BOTTOM_TEXT_2)}
            </li>
            <ul
              style={{ listStyleType: "circle" }}
              className="u-ml-large u-mb-small"
            >
              <li id="request-footer-text" className="u-1/1 u-p-none u-m-none">
                {i18n.t(rk.REQUEST_SELECTOR.QC_BOTTOM_TEXT_2_1_1)}
                <span
                  style={{ color: "#007eb2", cursor: "pointer" }}
                  onClick={() =>
                    window.open(`https://www.audifinance.ca/login`)
                  }
                  data-testid="myVWLink"
                >
                  {i18n.t(rk.REQUEST_SELECTOR.QC_BOTTOM_TEXT_2_1_2)}
                </span>
                {i18n.t(rk.REQUEST_SELECTOR.QC_BOTTOM_TEXT_2_1_3)}
              </li>
              <li id="request-footer-text" className="u-1/1 u-p-none u-m-none">
                {i18n.t(rk.REQUEST_SELECTOR.QC_BOTTOM_TEXT_2_2)}
              </li>
              <li id="request-footer-text" className="u-1/1 u-p-none u-m-none">
                {i18n.t(rk.REQUEST_SELECTOR.QC_BOTTOM_TEXT_2_3)}
              </li>
            </ul>
            <li id="request-footer-text" className="u-1/1 u-m-none u-pt-small">
              {i18n.t(rk.REQUEST_SELECTOR.QC_BOTTOM_TEXT_3)}
            </li>
            <ul
              style={{ listStyleType: "circle" }}
              className="u-ml-large u-mb-small"
            >
              <li id="request-footer-text" className="u-1/1 u-p-none u-m-none">
                {i18n.t(rk.REQUEST_SELECTOR.QC_BOTTOM_TEXT_3_1_1)}
                <span
                  style={{ color: "#007eb2", cursor: "pointer" }}
                  onClick={() => window.open(`https://www.vwfinance.ca/login/`)}
                  data-testid="myVWLink"
                >
                  {i18n.t(rk.REQUEST_SELECTOR.QC_BOTTOM_TEXT_3_1_2)}
                </span>
                {i18n.t(rk.REQUEST_SELECTOR.QC_BOTTOM_TEXT_3_1_3)}
              </li>
              <li id="request-footer-text" className="u-1/1 u-p-none u-m-none">
                {i18n.t(rk.REQUEST_SELECTOR.QC_BOTTOM_TEXT_3_2)}
              </li>
              <li id="request-footer-text" className="u-1/1 u-p-none u-m-none">
                {i18n.t(rk.REQUEST_SELECTOR.QC_BOTTOM_TEXT_3_3)}
              </li>
            </ul>
            <li id="request-footer-text" className="u-1/1 u-m-none u-pt-small">
              {i18n.t(rk.REQUEST_SELECTOR.QC_BOTTOM_TEXT_5)}
            </li>
            <ul
              style={{ listStyleType: "circle" }}
              className="u-ml-large u-mb-small"
            >
              <li id="request-footer-text" className="u-1/1 u-p-none u-m-none">
                {i18n.t(rk.REQUEST_SELECTOR.QC_BOTTOM_TEXT_5_1_1)}
                <span
                  style={{ color: "#007eb2", cursor: "pointer" }}
                  onClick={() => window.open(`https://my.audi.com/`)}
                  data-testid="myVWLink"
                >
                  {i18n.t(rk.REQUEST_SELECTOR.QC_BOTTOM_TEXT_5_1_2)}
                </span>
                {i18n.t(rk.REQUEST_SELECTOR.QC_BOTTOM_TEXT_5_1_3)}
              </li>
            </ul>
            <div id="request-footer-text" className="u-1/1 u-m-none">
              {i18n.t(rk.REQUEST_SELECTOR.QC_BOTTOM_TEXT_6)}
            </div>
            <div id="request-footer-text" className="u-1/1 u-m-none u-pt-small">
              {i18n.t(rk.REQUEST_SELECTOR.QC_BOTTOM_TEXT_7)}
              <br />
              {i18n.t(rk.REQUEST_SELECTOR.QC_BOTTOM_TEXT_8)}
            </div>
          </>
        );
      default:
        return <></>;
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    props.clearProtectionServicesExperianDetails();
  }, [props]);

  return (
    <>
      <div className="request-selector_title_question">{headerText(state)}</div>

      <RightsTable />

      <div className="request-footer-wrapper">
        <div id="request-footer-content" className="request-footer-content-2">
          {country.toLowerCase() === "canada" && (
            <div id="request-footer-text">{bottomText(state)}</div>
          )}
          <BottomLine />
        </div>
      </div>
    </>
  );
};

RequestSelector.propTypes = {
  stateSelector: PropTypes.shape({
    selectedFlow: PropTypes.string,
    currentStateResidence: PropTypes.string,
  }).isRequired,
  country: PropTypes.string.isRequired,
  clearProtectionServicesExperianDetails: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  stateSelector: state.stateSelector,
  country: state.initialReducer.country,
});
const mapDispatchToProps = (dispatch) => ({
  clearProtectionServicesExperianDetails: () =>
    dispatch(clearProtectionServicesExperianDetails()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(RequestSelector));
